export default class RoundedRect
{


  drawOn(ctx, x, y, width, height, radius)
  {


    ctx.moveTo(x + radius, y);
    // top
    ctx.lineTo(x + width - radius, y);
    // topright
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    // right
    ctx.lineTo(x + width, y + height - radius);

    // bottom right
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);

    // bottom
    ctx.lineTo(x + radius, y + height);

    // bottom left
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);

    // left
    ctx.lineTo(x, y + radius);

    // top left
    ctx.quadraticCurveTo(x, y, x + radius, y);

  }


}
